import { ajaxSend } from '../utils';
export default function submiter(form) {
    const formData = new FormData(form);
    const url = form.action;
    ajaxSend({ url, formData })
        .then((response) => {
        processing(response);
        // form.reset();
        // window.ym(56313895,'reachGoal', 'formSent');
    })
        .catch((err) => console.error(err));
    const processing = (pageSourceHtml) => {
        // console.log(pageSourceHtml);
        const timeInput = document.querySelector('input[name = "time"]');
        const dateInput = document.querySelector('input[name = "date"]');
        const header = document.querySelector('.appointment__header');
        header && header.classList.add('hide');
        const complite = document.querySelector('.appointment__form__wrapper');
        complite.innerHTML = `
            <div class="col-24 column">
                <h2>Вы записались на получение прицепа</h2>
                <p>Ждём вас <span class="bold">${dateInput.value}</span> в <span class="bold">${timeInput.value}</span></p>
                <p>Для получения товара при себе необходимо иметь:</p> 
                <ul>
                    <li>⁠для физических лиц: паспорт (или доверенность и паспорт доверенного);</li>
                    <li>⁠для юридических лиц: печать или доверенность и документ, удостоверяющий личность (паспорт).</li>
                </ul>
                <p>Для готовности документов ко времени Вашего визита необходимо заранее предоставить свои паспортные данные, для этого свяжитесь с вашим менеджером.</p>
            </div>
        `;
        // pageSourceHtml.indexOf('<div class="{$col-medium} justify-center column formPostedMessege">')
    };
}
;
